import { gql } from "@apollo/client";

export const PROFILE_UPDATE = gql`
    mutation profileUpdate($input: ProfileUpdateMutationInput!) {
        profileUpdate(input: $input) {
            errors {
                messages
            }
            userId
            phoneNumber
            studentNumber
            firstName
            lastName
            gender
            isActive
            dateJoined
            clientTz
            lessonRemindsAt
            lessonRemindsAtEnabled
            supportId
            birthYear
            martialStatus
            childrenCount
            province
            city
            profession
            eduType
            degree
            universityEdu
            hawzahEdu
            education
            chatPlatforms
        }
    }
`;
